import { RefObject, useEffect } from "react";

interface IntersectionObserverOptions {
  targetElementRef: RefObject<Element | undefined>;
  options?: IntersectionObserverInit;
  callback: () => void;
}

const defaultOptions: IntersectionObserverInit = {
  root: null,
  rootMargin: "0px",
  threshold: 1.0,
};

export const useIntersectionObserver = ({
  targetElementRef,
  callback,
  options = { ...defaultOptions },
}: IntersectionObserverOptions): void => {
  useEffect(() => {
    const observerEntries = (entries: IntersectionObserverEntry[]) => {
      // Assuming that there is only one target element that the [IntersectionObserver] is observing
      const [entry] = entries;
      if (entry.isIntersecting) callback();
    };

    const observer = new IntersectionObserver(observerEntries, options);

    if (!targetElementRef?.current) return;

    observer.observe(targetElementRef.current);

    return () => {
      if (!targetElementRef.current) return;

      observer.disconnect();
    };
  }, [targetElementRef, callback, options]);
};
